import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import logoWhite from '../assets/img/black_logo.png';

const navLinks = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About Us' },
  { to: '/profile', label: 'Profile' },
  { to: '/gallery', label: 'Gallery' },
  { to: '/services', label: 'Services' },
  { to: '/tours', label: 'Tours' },
  { to: '/hotel', label: 'Hotel' },
  { to: '/flights', label: 'Flights' },
  { to: '/contact', label: 'Contact' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed left-0 right-0 top-0 z-50 border-b border-white/10 bg-navy-950/90 backdrop-blur-md">
      <nav
        className="flex w-full items-center justify-between gap-3 px-3 py-3 sm:gap-4 sm:px-5 lg:px-8"
        aria-label="Primary"
      >
        <Link
          to="/"
          className="flex min-w-0 shrink-0 items-center gap-2 pr-2"
          onClick={() => setOpen(false)}
        >
          <img
            src={logoWhite}
            alt="RAYAN STAR CONSULTANCY & SERVICES CO. W.L.L."
            className="h-12 w-auto sm:h-14 md:h-16 lg:h-20"
          />
        </Link>

        <div className="hidden flex-1 items-center justify-center gap-4 xl:gap-6 2xl:gap-8 lg:flex">
          {navLinks.map((link) => (
            <NavLink
              key={link.to + link.label}
              to={link.to}
              className={({ isActive }) =>
                [
                  'whitespace-nowrap text-[13px] font-medium tracking-wide transition xl:text-sm',
                  isActive ? 'text-gold' : 'text-white/90 hover:text-gold',
                ].join(' ')
              }
            >
              {link.label}
            </NavLink>
          ))}
        </div>

        <div className="hidden items-center gap-3 xl:gap-4 2xl:gap-5 lg:flex">
          <a
            href="tel:+97333671305"
            className="flex items-center gap-2 whitespace-nowrap text-[13px] font-medium text-white/90 xl:text-sm"
          >
            <svg className="h-4 w-4 text-gold" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z"
              />
            </svg>
            +973 3367 1305
          </a>
          <a
            href="mailto:info@rayanstar.me"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-gold px-3 py-2 text-[13px] font-semibold text-navy shadow-sm transition hover:bg-gold-light xl:px-4 xl:text-sm"
          >
            <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
              />
            </svg>
            info@rayanstar.me
          </a>
        </div>

        <div className="flex items-center gap-2 lg:hidden">
          <button
            type="button"
            className="inline-flex items-center justify-center rounded-lg p-2 text-white"
            aria-expanded={open}
            aria-controls="mobile-menu"
            onClick={() => setOpen((v) => !v)}
          >
            <span className="sr-only">Toggle menu</span>
            {open ? (
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
              </svg>
            ) : (
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
              </svg>
            )}
          </button>
        </div>
      </nav>

      <div
        id="mobile-menu"
        className={`border-t border-white/10 bg-navy-950 lg:hidden ${open ? 'block' : 'hidden'}`}
      >
        <div className="flex flex-col gap-1 px-3 py-4 sm:px-5 lg:px-8">
          {navLinks.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              className={({ isActive }) =>
                [
                  'rounded-lg px-3 py-2 text-sm font-medium transition',
                  isActive
                    ? 'bg-gold/15 text-gold'
                    : 'text-white hover:bg-white/10',
                ].join(' ')
              }
              onClick={() => setOpen(false)}
            >
              {link.label}
            </NavLink>
          ))}
          <a href="tel:+97333671305" className="px-3 py-2 text-sm text-white/80">
            +973 3367 1305
          </a>
          <a
            href="mailto:info@rayanstar.me"
            className="mt-2 inline-flex items-center justify-center gap-2 rounded-md bg-gold px-4 py-2.5 text-sm font-semibold text-navy"
            onClick={() => setOpen(false)}
          >
            info@rayanstar.me
          </a>
        </div>
      </div>
    </header>
  );
}
